import React from 'react';
import { Form, InputGroup } from 'react-bootstrap';
import { Field, getIn } from 'formik';
import useTranslation from 'next-translate/useTranslation';

interface ITextField {
  as?: any;
  xs?: number;
  sm?: number;
  md?: number;
  lg?: number;
  xl?: number;
  label?: string;
  name: string;
  type: string;
  placeholder?: string;
  inputGroupPrepend?: any;
  onBlur?: any;
  min?: number;
  max?: number;
  readOnly?: boolean;
  maxLength?: number;
}

export const TextField = ({ label, name, type, onBlur, placeholder, inputGroupPrepend, min, max, readOnly, maxLength }: ITextField) => {
  const { t } = useTranslation('form-errors');

  return (
    <Field name={name}>
      {({ field, form }: { field: any; form: any }) => {
        const handleBlur = (event: React.FormEvent<HTMLInputElement>) => {
          field.onBlur(event);
          form.setFieldTouched(field.name); // Mark field as touched
          form.validateField(field.name); // Validate only this field

          // Trigger our own custom onBlur handler
          if (typeof onBlur === 'function') {
            onBlur(event);
          }
        };

        const feedback = getIn(form.errors, field.name) || getIn(form.status, field.name);
        const isTouched = getIn(form.touched, field.name);
        const isValid = isTouched && !getIn(form.errors, field.name);
        const isInvalid = !!feedback;

        return (
          <>
            <Form.Label className={isInvalid ? 'text-danger' : ''}>{label}&nbsp;</Form.Label>
            <InputGroup>
              {inputGroupPrepend}
              <Form.Control
                {...field}
                type={type}
                isValid={isValid}
                isInvalid={isInvalid}
                feedback={feedback}
                placeholder={placeholder ?? label}
                onBlur={handleBlur}
                data-testid={field.name}
                min={min}
                max={max}
                readOnly={readOnly}
                maxLength={maxLength}
              />

              <Form.Control.Feedback type="invalid">{feedback && t(feedback)}</Form.Control.Feedback>
            </InputGroup>
          </>
        );
      }}
    </Field>
  );
};
